class HomeCollections {
  constructor(section) {
    this.section = section;
    if (!this.section) return;

    this.swiperEl = this.section.querySelector('.swiper');
		if (!this.swiperEl || typeof Swiper === 'undefined') return;

    this.allSlides = this.swiperEl.querySelectorAll('.swiper-slide');

    this.init();
  }
  
  init() {
    let swiperOpts = {
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      allowTouchMove: true,
      speed: 800,
      navigation: {
        nextEl: this.section.querySelector('.swiper-button-next'),
        prevEl: this.section.querySelector('.swiper-button-prev')
      },
      pagination: {
        el: this.section.querySelector('.swiper-pagination'),
        clickable: true,
        renderBullet: (index, className) => {
          const slide = this.allSlides[index];
          const heading = slide.querySelector('h2');
          const title = heading ? heading.textContent.trim() : index + 1;
          
          return `<span class="${className}">${title}</span>`;
        }
      }
    }

    if (this.swiperEl.dataset.swiperAutoplay) {
      swiperOpts.autoplay = {
        delay: Number(this.swiperEl.dataset.swiperAutoplay),
        disableOnInteraction: false
      };
    }

    this.swiper = new Swiper(this.swiperEl, swiperOpts);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.home-collections').forEach(section => {
    new HomeCollections(section);
  });
});